import React, { useEffect } from 'react'
import { TabPanel } from 'primereact/tabview'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { CustomPanel, CustomTabView, PageHeader } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import Faltas from './Faltas/Faltas'
import Sobras from './Sobras/Sobras'
import EmitirResumo from './EmitirResumo/EmitirResumo'
import useResumoSeparacao, { LOAD_MESSAGE } from './ResumoSeparacaoHook'

function ResumoSeparacao({ history, dispatch, selectedPicking }) {
  const { state, localDispatch } = useResumoSeparacao()

  useEffect(() => {
    if (selectedPicking) localDispatch.onInit(selectedPicking)
    else history.goBack()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.INITIAL_FETCH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
        localDispatch.getResumoInfo(state.selectedPicking)
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>
        <span>
          {selectedPicking.style === 'Manual'
            ? '4.4.7'
            : selectedPicking.style === 'Reconferencia'
              ? '4.8.7'
              : '4.3.7'}{' '}
          - Resumo de Separação:
        </span>
        <strong>
          {state.selectedPicking
            ? `${state.selectedPicking.name} - ${state.selectedPicking.company_name}`
            : ''}
        </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={() => history.goBack()}>
          <CustomTabView activeIndex={state.tabActiveIndex}>
            <TabPanel header="Apuração das Faltas" disabled={false}>
              <Faltas
                faltasItems={state.missing_products}
                reasons={state.missing_reasons
                  .filter(r => r.type === 'Falta')
                  .map(r => ({ id: r.id, name: r.name }))}
                onDesdobrado={localDispatch.reload}
              />
            </TabPanel>
            <TabPanel header="Sobras" disabled={false}>
              <Sobras
                sobrasItems={state.leftover_products}
                reasons={state.missing_reasons
                  .filter(r => r.type === 'Sobra')
                  .map(r => ({ id: r.id, name: r.name }))}
                onAjustado={localDispatch.reload}
              />
            </TabPanel>
            <TabPanel header="Resumo de Separação" disabled={false}>
              <EmitirResumo
                faltasItems={state.missing_products}
                sobrasItems={state.leftover_products}
                tipo="Codigo de Barra"
              />
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(withRouter(ResumoSeparacao))
